import { DEFAULT_LANGUAGE } from 'affiny-core/translations/constants';
import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .use(new ICU())
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: DEFAULT_LANGUAGE,
    resources: {},
  });

export default i18n;
